export default __webpack_public_path__ + "static/media/mail-rounded.bdff900d.svg";